"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4481],{

/***/ 64481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30555);
/* harmony import */ var _styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32866);










const Studyabroadjourney = ({ studyabrdata , jotformId , slug , externalLink  })=>{
    const buttonLabel = slug === "nagpur" ? "Enquire Now" : "Book Free Online Counselling";
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "study_abroadjourney",
        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studywithScholarship),
        style: {
            backgroundColor: studyabrdata?.sectionBgColor || "#fff"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heading),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: studyabrdata?.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            xl: 4,
                            lg: 4,
                            md: 4,
                            sm: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default().stuImg),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: studyabrdata?.sectionImageUrl || "/images/gilrwithpassport.png",
                                    width: 518,
                                    height: 429,
                                    alt: "EdTech1"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            xl: 8,
                            lg: 8,
                            md: 8,
                            sm: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default().OffersContent),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ulItem),
                                        children: studyabrdata?.sectionPoints?.length > 0 && studyabrdata.sectionPoints.map((studyabroaddata, ind)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: studyabroaddata
                                            }, ind);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !jotformId && generateLink(externalLink);
                                            },
                                            className: `${(_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnReg)}${jotformId ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isFrappeOrJotFormClass */ .gd)(jotformId)}` : ""}`,
                                            children: buttonLabel
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Studyabroadjourney);


/***/ })

}]);